<div class="je-modal-container je   -confirm">
    <h2 mat-dialog-title>{{title}}</h2>
    <mat-dialog-content>
      {{body}}
      <div>{{lowerBody}}</div>
  
    </mat-dialog-content>
    <mat-dialog-actions>
      <!-- <span>
        <mat-checkbox *ngIf="this.data.needCheckox" [(ngModel)]="accepted" labelPosition="after">Publish Status Report</mat-checkbox>
      </span> -->
      <span>
        <button mat-button mat-raised-button [mat-dialog-close]="false" cdkFocusInitial>Cancel</button>
        <button mat-button mat-raised-button [mat-dialog-close]="true">{{ok}}</button>
      </span>
    </mat-dialog-actions>
  </div>